import { networkAction } from "helpers/network/networkAction";

import {
  GET_CARTS,
  GET_CART_BY_ID,
  GET_CURRENT_CART,
  DELETE_CART,
  UPDATE_CART,
  PAY_CART,
  CREATE_CART,
  VALIDATE_CART,
} from "constants/carts";

import * as Api from "api";

export const getCarts = () => async (dispatch) =>
  networkAction(dispatch, GET_CARTS, Api.getCarts, []);

export const getCurrentCart = () => async (dispatch) =>
  networkAction(dispatch, GET_CURRENT_CART, Api.getCurrentCart, []);

export const validateCart = (cart) => async (dispatch) =>
  networkAction(dispatch, VALIDATE_CART, Api.validateCart, [cart]);

export const getCartById = (id) => async (dispatch) =>
  networkAction(dispatch, GET_CART_BY_ID, Api.getCartById, [id]);

export const payCart = (id, body) => async (dispatch) =>
  networkAction(dispatch, PAY_CART, Api.payCart, [id, body]);

export const deleteCart = (id) => async (dispatch) =>
  networkAction(dispatch, DELETE_CART, Api.deleteCart, [id]);

export const createCart = (body) => async (dispatch) =>
  networkAction(dispatch, CREATE_CART, Api.createCart, [body]);

export const updateCart = (id, body) => async (dispatch) =>
  networkAction(dispatch, UPDATE_CART, Api.updateCart, [id, body]);
